class ResetPasswordController {
    static create(params) {
        return new ResetPasswordController(params);
    }

    constructor({env}) {
        this.env = env;
        this.dialog = env.getDialog('reset-password-dialog');

        this.initEvents();
    }

    initEvents() {
        this.env.onNav('resetPassword', ({email}) => this.show({email}));

        this.dialog.on('hideGesture', () => this.navToSignIn());
        this.dialog.on('submitGesture', () => this.onSubmitGesture());
        this.dialog.on('createAccountLink:click', () => this.onCreateAccountClick());
    }

    getEmail() {
        return this.dialog.getEmail();
    }

    navToSignIn() {
        this.env.navTo('userSignIn', {email: this.getEmail()});
    }

    onCreateAccountClick() {
        this.env.navTo('createAccount', {email: this.getEmail()});
    }

    onSubmitGesture() {
        var email = this.getEmail();

        this.dialog.clearErrors();

        if (!this.env.isValidEmail(email)) {
            this.dialog.addEmailError();
            this.dialog.focusEmailField();
            return;
        }

        this.dialog.setSubmitting(true);

        this.env.getProxy().requestPasswordReset({email})
            .then(() => {
                this.dialog.setSubmitting(false);

                this.env.showDialog('reset-password-success-dialog').then(() => this.navToSignIn());
            })
            .catch(error => {
                this.dialog.setSubmitting(false);

                if (error.hasType('UnknownUser')) {
                    this.dialog.addUnknownUserError();
                    return;
                }

                throw error;
            });
    }

    show({email}) {
        this.dialog.clearErrors();
        this.dialog.setEmail(email);
        this.dialog.show();
        this.dialog.focusEmailField();
    }
}

export default ResetPasswordController;